import { gql } from '@apollo/client';

export type FederalTaxClassification =
    | 'INDIVIDUAL'
    | 'SOLE_PROPRIETOR'
    | 'PARTNERSHIP'
    | 'LLC_SOLE_PROPRIETOR'
    | 'C_CORPORATION'
    | 'S_CORPORATION'
    | 'LLC_C_CORPORATION'
    | 'LLC_S_CORPORATION';

export type TaxIdType = 'EIN' | 'SSN' | 'ITIN' | 'FOREIGN_TAX_ID';

export type BankAccountType = 'CHECKING' | 'SAVINGS';

export const FEDERAL_TAX_CLASSIFICATIONS: FederalTaxClassification[] = [
    'INDIVIDUAL',
    'SOLE_PROPRIETOR',
    'PARTNERSHIP',
    'LLC_SOLE_PROPRIETOR',
    'C_CORPORATION',
    'S_CORPORATION',
    'LLC_C_CORPORATION',
    'LLC_S_CORPORATION'
];

export const TAX_ID_TYPES: TaxIdType[] = ['EIN', 'SSN', 'ITIN', 'FOREIGN_TAX_ID'];

export const BANK_ACCOUNT_TYPES: BankAccountType[] = ['CHECKING', 'SAVINGS'];

/** 供应商国家当前仅支持美国 */
export const VENDOR_COUNTRY_US = 'US';

/**
 * trackFor1099 由服务端按 federalTaxClassification 派生，前端只读展示
 */
export const TRACK_FOR_1099_BY_CLASSIFICATION: Record<FederalTaxClassification, boolean> = {
    INDIVIDUAL: true,
    SOLE_PROPRIETOR: true,
    PARTNERSHIP: true,
    LLC_SOLE_PROPRIETOR: true,
    C_CORPORATION: false,
    S_CORPORATION: false,
    LLC_C_CORPORATION: false,
    LLC_S_CORPORATION: false
};

export interface DspFinanceInfoType {
    dspId: string;
    vendorCountry?: string | null;
    federalTaxClassification?: FederalTaxClassification | null;
    taxIdType?: TaxIdType | null;
    taxIdNumber?: string | null;
    trackFor1099?: boolean | null;
    bankName?: string | null;
    accountType?: BankAccountType | null;
    accountNo?: string | null;
    routingNo?: string | null;
    vendorAddress?: string | null;
    /** true 表示税号与银行账号为掩码值，不可用于回填保存 */
    masked: boolean;
    /** 必填项是否已齐全；DSP Owner 端齐全后只读 */
    completed: boolean;
}

export interface DspFinanceInfoInput {
    vendorCountry?: string | null;
    federalTaxClassification?: FederalTaxClassification | null;
    taxIdType?: TaxIdType | null;
    taxIdNumber?: string | null;
    bankName?: string | null;
    accountType?: BankAccountType | null;
    accountNo?: string | null;
    routingNo?: string | null;
    vendorAddress?: string | null;
}

export const DSP_FINANCE_INFO_FIELDS = gql`
    fragment DspFinanceInfoFields on DspFinanceInfoType {
        dspId
        vendorCountry
        federalTaxClassification
        taxIdType
        taxIdNumber
        trackFor1099
        bankName
        accountType
        accountNo
        routingNo
        vendorAddress
        masked
        completed
    }
`;
